module.exports = __webpack_public_path__ + "img/2ca80f2.jpg";